import type { LoaderFunction } from 'react-router'
import { fetchUserAttributes } from 'aws-amplify/auth'

export const emailLoader: LoaderFunction = async () =>
  fetchUserAttributes().then((attributes) => attributes.email)
